

import './ConfigureSocial.scss';

import React, { FC } from 'react';
import SocialSetup from 'modules/Social/SocialSetup/SocialSetup';
import Form from 'react-bootstrap/esm/Form';

import { WizardStepInfo } from '../SetupWizard/WizardStepInfo';
import WizardActions from '../WizardActions/WizardActions';

interface ConfigureSocialProps extends WizardStepInfo {
  onComplete: (event: any) => void;
}

const ConfigureSocial: FC<ConfigureSocialProps> = ({ onComplete, ...wizardContext }) => {
  const stepBackTwo = (_: any) => {
    wizardContext.goToStep(wizardContext.currentStep - 2);
  };

  return (
    <div className="ConfigureSocial">
      <Form noValidate>
        <SocialSetup />
        <WizardActions {...wizardContext} previousStep={stepBackTwo} nextStep={onComplete} />
      </Form>
    </div>
  );
};

export default ConfigureSocial;
